import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-735cd1a8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tw-flex tw-bg-[#FFF]" }
const _hoisted_2 = { class: "tw-w-[100%] tw-p-[20px] tw-min-h-[73px] tw-border tw-border-solid tw-rounded-s-md tw-border-[#EFF0F1]" }
const _hoisted_3 = { class: "tw-flex tw-items-center tw-justify-between tw-mb-[13px] tw-w-[100%] tw-h-[20px]" }
const _hoisted_4 = { class: "tw-text-[15px] tw-font-[600] tw-leading-[130%] tw-text-[#211F58]" }
const _hoisted_5 = {
  key: 0,
  class: "custom-global-skeleton tw-w-[100px] tw-h-[23px] tw-rounded-[4px] tw-text-[11px] tw-font-[500] tw-leading-[130%] tw-cursor-pointer tw-px-[5px] tw-py-[3px] ${statusStyle}"
}
const _hoisted_6 = {
  key: 1,
  class: "custom-global-skeleton tw-w-[100px] tw-h-[23px] tw-rounded-[4px] tw-text-[11px] tw-font-[500] tw-leading-[130%] tw-cursor-pointer tw-px-[5px] tw-py-[3px] ${statusStyle}"
}
const _hoisted_7 = { class: "tw-h-[40px]" }
const _hoisted_8 = { class: "tw-flex tw-items-center tw-justify-between tw-mb-[6px]" }
const _hoisted_9 = { class: "tw-text-[13px] tw-font-[500] tw-leading-[130%] tw-text-[#211F58]" }
const _hoisted_10 = {
  key: 0,
  class: "custom-global-skeleton tw-h-[17px] tw-w-[100px]"
}
const _hoisted_11 = {
  key: 1,
  class: "custom-global-skeleton tw-h-[17px] tw-w-[100px]"
}
const _hoisted_12 = {
  key: 2,
  class: "tw-text-[13px] tw-font-[400] tw-text-[#878787] tw-leading-[130%]"
}
const _hoisted_13 = { class: "tw-flex tw-items-center tw-justify-between" }
const _hoisted_14 = { class: "tw-text-[13px] tw-font-[500] tw-leading-[130%] tw-text-[#211F58]" }
const _hoisted_15 = {
  key: 0,
  class: "custom-global-skeleton tw-h-[17px] tw-w-[100px]"
}
const _hoisted_16 = {
  key: 1,
  class: "custom-global-skeleton tw-h-[17px] tw-w-[100px]"
}
const _hoisted_17 = {
  key: 2,
  class: "tw-text-[13px] tw-font-[400] tw-text-[#878787] tw-leading-[130%]"
}
const _hoisted_18 = {
  style: {"border-top":"1px solid #eff0f1","border-right":"1px solid #eff0f1","border-bottom":"1px solid #eff0f1"},
  class: "tw-p-[20px] tw-bg-[#FFF] tw-max-h-[114px] tw-max-w-[114px] tw-rounded-r-md tw-border-[#EFF0F1]"
}

import { getComponentUiText, getElapsedTime } from "@/utils/utilities";
import RadialProgressBar from "../prospect/prospectQuestions/componentTypes/radialProgressBar.vue";
import { computed, PropType } from "vue";
import { getTimeFromNow } from "@/utils/dateTimeUtils";
import type { ScansHistoryWebServicesType } from "@/store/scanning";
import store from "@/store";
import dayjs from "dayjs";


export default /*#__PURE__*/_defineComponent({
  __name: 'scanStatusMiniDash',
  props: {
  percentProgress: {
    type: Number,
    required: false,
    default: 20,
  },
  data: {
    type: Object as PropType<
      ScansHistoryWebServicesType["scanReportRuns"][number]
    >,
    required: true,
  },
  webServicesId: {
    type: String,
    required: true,
  },
  domainId: {
    type: String,
    required: true,
  },
},
  setup(__props) {

const props = __props;



const statusStyle = computed(() => {
  return props.data?.runStatusId;
});

const currentScanStatus = computed(() => {
  return props.data?.runStatus;
});

const isRefreshing = computed(() => store.state.Scanning.isLoading);
const webserviceScanningId = computed(
  () => store.state.Scanning.webserviceScanningId,
);
const domainScanningId = computed<string>(
  () => store.state.Scanning.domainScanningId,
);

const getStartedTime = (time: string) => {
  return getTimeFromNow(time);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(getComponentUiText)("app-scan-scanning-scan-status-1")), 1),
        (isRefreshing.value && __props.webServicesId === webserviceScanningId.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5))
          : (isRefreshing.value && __props.domainId === domainScanningId.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6))
            : (_openBlock(), _createElementBlock("div", {
                key: 2,
                class: _normalizeClass(`tw-rounded-[4px] tw-text-[11px] tw-font-[500] tw-leading-[130%] tw-cursor-pointer tw-px-[5px] tw-py-[3px] ${statusStyle.value}`)
              }, _toDisplayString(currentScanStatus.value), 3))
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("span", _hoisted_9, _toDisplayString(_unref(getComponentUiText)("app-scan-scanning-scan-status-started-1")), 1),
          (isRefreshing.value && __props.webServicesId === webserviceScanningId.value)
            ? (_openBlock(), _createElementBlock("span", _hoisted_10))
            : (isRefreshing.value && __props.domainId === domainScanningId.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_11))
              : (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(getStartedTime(__props.data.startedAt)), 1))
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("span", _hoisted_14, _toDisplayString(_unref(getComponentUiText)("app-scan-scanning-scan-elapsed-time-1")), 1),
          (isRefreshing.value && __props.webServicesId === webserviceScanningId.value)
            ? (_openBlock(), _createElementBlock("span", _hoisted_15))
            : (isRefreshing.value && __props.domainId === domainScanningId.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_16))
              : (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(_unref(getElapsedTime)(__props.data.startedAt, __props.data.endedAt)), 1))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_18, [
      _createVNode(RadialProgressBar, {
        class: "d-inline",
        "total-steps": 100,
        "completed-steps": __props.percentProgress,
        "is-hide-progress": true,
        "outer-stroke-color": "#48A0FF"
      }, null, 8, ["completed-steps"])
    ])
  ]))
}
}

})